/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { useContext } from 'react';
import { LocalizationContext } from 'src/core/utils/contexts/LocalizationContext';

/**
 * Hook to support components with intl properties.
 *
 * @return
 * The saved InjectedIntl object that contain the current used locale, defineMessage fn, ... .
 */
export const useLocalization = () => {
    const intl = useContext(LocalizationContext);

    return { localize: intl.formatMessage, ...intl };
};
